var LGFG = LGFG || {};
LGFG.CP = LGFG.CP || {};

LGFG.CP.CustomerSolutionsMapFilter = LGFG.CP.CustomerSolutionsMapFilter || (function () {

    // Define settings defaults
    var _settings = {
        textSearchElementSelector: undefined,
        textSearchSubmitElementSelector: undefined,
        productTypeSelectorElementSelector: undefined,
        locationDropdownElementSelector: undefined,
        industryDropdownElementSelector: undefined
    };

    var _filterData = {
        searchText: undefined,
        productTypes: undefined,
        location: undefined,
        industry:  function () {
            var industry = $.urlParam('industry');
            
            if (industry !== null) {
                return industry;
            }
            return undefined;
        }
    }

    var _getFilterData = function () {
        
        return _filterData;
    }

    var _mapObject = null

    var _filterChanged = function (mapConfig) { };
    var _filterCleared = function () { };

    function searchMap() {
        _filterChanged(undefined);
    }

    var bindEvents = function () {
        // bind filter events

        if (typeof (_settings.textSearchElementSelector) !== 'undefined' && typeof (_settings.textSearchSubmitElementSelector) !== 'undefined') {
            $(_settings.textSearchSubmitElementSelector)
                .click(function (e) {
                    e.preventDefault();
                    var $textField = $(_settings.textSearchElementSelector);
                    _filterData.searchText = $textField.val();
                    searchMap();
                });
        }

        if (typeof (_settings.productTypeSelectorElementSelector) !== 'undefined') {
            $(_settings.productTypeSelectorElementSelector)
                .find('button')
                .click(function (e) {
                    e.preventDefault();
                    var $this = $(this);
                    $this.toggleClass('selected');
                    _filterData.productTypes = $(_settings.productTypeSelectorElementSelector).find('button.selected').map(function (i, e) { return $(e).data('value'); }).get();
                    searchMap();
                });
        }

        if (typeof (_settings.locationDropdownElementSelector) !== 'undefined') {
            $(_settings.locationDropdownElementSelector)
                .find('a[data-role="select-item"]')
                .click(function (e) {
                    e.preventDefault();
                    var $this = $(this);
                    $(_settings.locationDropdownElementSelector)
                        .find('a[data-role="display-value"]')
                        .text($this.text())
                        .data('value', $this.data('value'));
                    _filterData.location = $this.data('value');
                    searchMap();
                });
        }

        if (typeof (_settings.industryDropdownElementSelector) !== 'undefined') {
            $(_settings.industryDropdownElementSelector)
                .find('a[data-role="select-item"]')
                .click(function (e) {
                    e.preventDefault();
                    var $this = $(this);
                    $(_settings.industryDropdownElementSelector)
                        .find('a[data-role="display-value"]')
                        .text($this.text())
                        .data('value', $this.data('value'));
                    _filterData.industry = $this.data('value');
                    searchMap();
                    history.pushState({}, '', window.location.pathname);
                });
        }
    };

    var init = function (mapObject, settings, filterChanged, filterCleared) {

        if (typeof (mapObject) === 'undefined') {
            alert('map object is not defined');
            throw 'Map object is not defined';
        }

        _mapObject = mapObject;

        // Override settings defaults if specified
        if (typeof (settings) !== 'undefined') {
            _settings = settings;
        }

        if (typeof (filterChanged) !== 'undefined') {
            _filterChanged = filterChanged;
        }

        if (typeof (filterCleared) !== 'undefined') {
            _filterCleared = filterCleared;
        }

        bindEvents();
    };

    return {
        init: init,
        getData: _getFilterData
    };
})();